import { render, staticRenderFns } from "./HtTrainingBadge.vue?vue&type=template&id=463bd103&scoped=true&"
import script from "./HtTrainingBadge.vue?vue&type=script&lang=js&"
export * from "./HtTrainingBadge.vue?vue&type=script&lang=js&"
import style0 from "./HtTrainingBadge.vue?vue&type=style&index=0&id=463bd103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463bd103",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/pzuber/Desktop/Repozytoria/HairTalk/hairtalk/HairTalk/HT_Portal_VUE/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VBadge,VContainer,VIcon})
